//
// Usage: 
//  import prototypes from '@shared/lib/prototypes'
//

// 
// const items = [{ id: 10 }, { id: 3 }, { id: 7 }];
// const lowest = items.lowestProperty(x => x.id, 0); // returns 3
// 
// const items = [];
// const lowest = items.lowestProperty(x => x.id, 4); // returns 4
// 
Object.defineProperty(Array.prototype, "lowestProperty", {
  value: function (selector, defaultValue = undefined) {
    if (this.length === 0) return defaultValue;
    var item = this.reduce((best, item) =>
      selector(item) < selector(best) ? item : best
    );
    return selector(item);
  },
  enumerable: false
});

Object.defineProperty(Array.prototype, "highestProperty", {
  value: function (selector, defaultValue = undefined) {
    if (this.length === 0) return defaultValue;
    var item = this.reduce((best, item) =>
      selector(item) > selector(best) ? item : best
    );
    return selector(item);
  },
  enumerable: false
});
